(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/onboarding-handler/assets/onboarding-data.js') >= 0) return;  svs.modules.push('/components/accountservices/onboarding-handler/assets/onboarding-data.js');
'use strict';

var _svs;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const isServer = typeof exports === 'object';
const path = isServer ? require('path') : undefined;
const urlMapping = isServer ? require('@svenskaspelab/trinidad-core').core.urlMapping : (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 ? void 0 : _svs.urlMapping;
const DOMAIN = 'customer_login';
const PROPERTY = 'extraParams';

const SESSION_METHOD = {
  SET: 'set',
  GET: 'get',
  REMOVE: 'remove'
};

const isLoggedIn = req => isServer ? req.userSession && req.userSession.hasRole(req.userSession.roles.PLAYER) : svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);

const ENTRY_POINTS = {
  1: 'Högermeny Logga in',
  2: 'Högermeny Bli kund',
  3: 'Vattendelaren Logga in',
  4: 'Vattendelaren Bli kund'
};

const sanitizeEntryPoint = entryPoint => {
  const value = typeof entryPoint === 'number' || typeof entryPoint === 'string' ? String(entryPoint) : undefined;
  return value !== undefined && Object.prototype.hasOwnProperty.call(ENTRY_POINTS, value) ? value : undefined;
};

const RETURN_URL_ENTRY_POINT_MAPPINGS = [{
  urlMappingKey: 'myBetsHome',
  label: 'Mina spel'
}, {
  urlMappingKey: 'playTogetherTeams',
  label: 'Mina lag'
}, {
  urlMappingKey: 'transactionsHome',
  label: 'Sätt in pengar'
}, {
  urlMappingKey: 'transactionsWithdrawal',
  label: 'Ta ut pengar'
}, {
  urlMappingKey: 'transactionsAccountHistory',
  label: 'Kontohistorik'
}, {
  urlMappingKey: 'myBetsHistory',
  label: 'Spelhistorik'
}, {
  urlMappingKey: 'myLimits',
  label: 'Mina gränser'
}, {
  urlMappingKey: 'gamingResponsibilityPause',
  label: 'Spelpaus'
}, {
  urlMappingKey: 'myProfileHome',
  label: 'Min profil'
}, {
  urlMappingKey: 'grassrootsTeams',
  label: 'Mina gräsrotenval'
}];
let _returnUrlEntryPointsCache = null;

const getReturnUrlEntryPoints = () => {
  if (_returnUrlEntryPointsCache) {
    return _returnUrlEntryPointsCache;
  }
  if (!urlMapping) {
    return {};
  }
  _returnUrlEntryPointsCache = {};
  for (const _ref of RETURN_URL_ENTRY_POINT_MAPPINGS) {
    const urlMappingKey = _ref.urlMappingKey;
    const label = _ref.label;
    const resolvedPath = urlMapping.get(urlMappingKey);
    if (resolvedPath) {
      _returnUrlEntryPointsCache[resolvedPath] = label;
    }
  }
  return _returnUrlEntryPointsCache;
};

const TRIGGER_PREFIXES = {
  'right menu': 'Högermeny',
  'left menu': 'Vänstermeny'
};

const getDeviceSessionValue = (property, domain) => new Promise(resolve => {
  svs.core.deviceSession.get(property, domain, (result, err) => {
    if (err || !result) {
      resolve(undefined);
    } else {
      resolve(result);
    }
  });
});

const setDeviceSessionValue = (property, domain, value) => new Promise(resolve => {
  svs.core.deviceSession.set(property, domain, value, () => {
    resolve();
  });
});

async function saveEntryPoint(extraParams, returnUrl, req) {
  if (isLoggedIn(req)) {
    return;
  }
  const product = extraParams !== null && extraParams !== void 0 && extraParams.product ? " ".concat(extraParams.product) : '';
  let entryPointValue;
  if (extraParams !== null && extraParams !== void 0 && extraParams.entryPoint) {
    entryPointValue = ENTRY_POINTS[extraParams.entryPoint] || 'Unknown';
  } else if (extraParams !== null && extraParams !== void 0 && extraParams.amount && extraParams !== null && extraParams !== void 0 && extraParams.product) {
    entryPointValue = "Betala".concat(product);
  } else if (extraParams !== null && extraParams !== void 0 && extraParams.gift) {
    entryPointValue = "Presentkod".concat(product);
  } else if (extraParams !== null && extraParams !== void 0 && extraParams.subscription) {
    entryPointValue = "Prenumeration".concat(product);
  } else if (extraParams !== null && extraParams !== void 0 && extraParams.validateticketonline) {
    entryPointValue = "R\xE4tta lotten".concat(product);
  } else if (extraParams !== null && extraParams !== void 0 && extraParams.ticketsorderhome) {
    entryPointValue = "Best\xE4ll hem".concat(product);
  } else if (returnUrl) {
    const decodedReturnUrl = decodeURIComponent(returnUrl);
    const matchedEntryPoint = Object.entries(getReturnUrlEntryPoints()).find(_ref2 => {
      let _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];
      return decodedReturnUrl.startsWith(key);
    });
    const destination = matchedEntryPoint ? matchedEntryPoint[1] : 'Unknown';

    const trigger = isServer ? req.session['Users.entry_point_trigger'] : await getDeviceSessionValue('entry_point_trigger', 'Users');
    const triggerPrefix = TRIGGER_PREFIXES[trigger];
    entryPointValue = triggerPrefix ? "".concat(triggerPrefix, " ").concat(destination) : destination;
  }
  if (entryPointValue) {
    if (isServer) {
      req.session['Users.entry_point'] = entryPointValue;
    } else {
      await setDeviceSessionValue('entry_point', 'Users', entryPointValue);
    }
  }
}

const checkAllParamsUndefined = extraParams => {
  let hasAllUndefinedExtraParams = true;
  for (const param of Object.values(extraParams)) {
    if (typeof param !== 'undefined') {
      hasAllUndefinedExtraParams = false;
      break;
    }
  }
  return hasAllUndefinedExtraParams;
};

const stringToBool = string => {
  var _string$toLowerCase;
  const lowString = string === null || string === void 0 || (_string$toLowerCase = string.toLowerCase) === null || _string$toLowerCase === void 0 ? void 0 : _string$toLowerCase.call(string);
  switch (lowString) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return undefined;
  }
};

const convertUndefined = parameter => {
  var _parameter$toLowerCas;
  return (parameter === null || parameter === void 0 || (_parameter$toLowerCas = parameter.toLowerCase) === null || _parameter$toLowerCas === void 0 ? void 0 : _parameter$toLowerCas.call(parameter)) === 'undefined' ? undefined : parameter;
};

const handleSessionDataClientsideAsync = _ref4 => {
  let _ref4$sessionMethod = _ref4.sessionMethod,
    sessionMethod = _ref4$sessionMethod === void 0 ? SESSION_METHOD.GET : _ref4$sessionMethod,
    value = _ref4.value,
    _ref4$forceDeviceSess = _ref4.forceDeviceSessionCall,
    forceDeviceSessionCall = _ref4$forceDeviceSess === void 0 ? false : _ref4$forceDeviceSess;
  return new Promise(resolve => {
    const isSet = sessionMethod === SESSION_METHOD.SET;
    const isGet = sessionMethod === SESSION_METHOD.GET;
    const isRemove = sessionMethod === SESSION_METHOD.REMOVE;
    const fnBase = !isLoggedIn() || forceDeviceSessionCall ? svs.core.deviceSession : svs.core.userSession;
    const fn = isSet ? fnBase.set : isGet ? fnBase.get : isRemove ? fnBase.remove : () => {};
    const promiseCallback = function () {
      for (var _len = arguments.length, callbackParams = new Array(_len), _key = 0; _key < _len; _key++) {
        callbackParams[_key] = arguments[_key];
      }
      const first = callbackParams[0],
        second = callbackParams[1];
      const isResultParamFirst = isGet && !isLoggedIn();
      const result = isResultParamFirst ? first : second;
      const err = isResultParamFirst ? second : first;
      if (err) {
        resolve();
      } else {
        result && resolve(result) || resolve();
      }
    };
    const params = !isLoggedIn() || forceDeviceSessionCall ? [PROPERTY, DOMAIN, promiseCallback] : ["".concat(DOMAIN, ".").concat(PROPERTY), promiseCallback];
    if (!isSet && !isGet && !isRemove) {
      resolve();
    }
    if (isSet) {
      params.splice(params.length - 1, 0, value);
    }
    fn.call(fnBase, ...params);
  });
};

const getExtraData = async req => {
  let extraParams;
  if (isServer) {
    extraParams = isLoggedIn(req) ? req.userSession.get("".concat(DOMAIN, ".").concat(PROPERTY)) : req.session["".concat(DOMAIN, ".").concat(PROPERTY)];
  } else {
    extraParams = await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.GET
    });
  }
  return extraParams;
};

const setExtraData = async _ref5 => {
  let extraParams = _ref5.extraParams,
    req = _ref5.req;
  if (isServer) {
    if (isLoggedIn(req)) {
      req.userSession.set("".concat(DOMAIN, ".").concat(PROPERTY), extraParams);
    } else {
      req.session["".concat(DOMAIN, ".").concat(PROPERTY)] = extraParams;
    }
  } else {
    extraParams = await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.SET,
      value: extraParams
    });
  }
  return extraParams;
};

const updateExtraData = async _ref6 => {
  let newExtraData = _ref6.newExtraData,
    req = _ref6.req;
  let extraParams;

  extraParams = await getExtraData(req);
  extraParams = _objectSpread(_objectSpread({}, extraParams), newExtraData);
  await setExtraData({
    extraParams,
    req
  });
  return extraParams;
};

const clearExtraData = async req => {
  if (isServer) {
    if (isLoggedIn(req)) {
      req.userSession.remove("".concat(DOMAIN, ".").concat(PROPERTY));
    }
    req.session["".concat(DOMAIN, ".").concat(PROPERTY)] = undefined;
  } else {
    await handleSessionDataClientsideAsync({
      sessionMethod: SESSION_METHOD.REMOVE
    });
    if (isLoggedIn()) {
      await handleSessionDataClientsideAsync({
        sessionMethod: SESSION_METHOD.REMOVE,
        forceDeviceSessionCall: true
      });
    }
  }
};

const setupExtraData = async _ref7 => {
  let extraData = _ref7.extraData,
    forceDefault = _ref7.forceDefault,
    req = _ref7.req;
  const onboardingTheme = isServer ? require(path.join(__dirname, 'onboarding-theme.es6')) : svs.accountservices.onboardingHandler;
  const returnUrl = extraData.returnUrl;
  const entryPoint = sanitizeEntryPoint(extraData.ep);
  let amount = extraData.amount,
    branding = extraData.branding,
    isForceShortOnboarding = extraData.forceShortOnboarding,
    isGift = extraData.gift,
    isReactivatedCustomer = extraData.isReactivatedCustomer,
    isRetailCustomer = extraData.isRetailCustomer,
    product = extraData.product,
    isSubscription = extraData.subscription,
    team = extraData.team,
    isTicketsOrderHome = extraData.ticketsorderhome,
    isValidateTicketOnline = extraData.validateticketonline,
    weeks = extraData.weeks;
  let extraParams;
  let theme;

  if (forceDefault) {
    await clearExtraData(req);
    theme = onboardingTheme.getTheme();
    extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
      theme,
      entryPoint
    });
  } else {
    var _weeks, _weeks$toLowerCase;

    isSubscription = stringToBool(isSubscription);
    isGift = stringToBool(isGift);
    isValidateTicketOnline = stringToBool(isValidateTicketOnline);
    isTicketsOrderHome = stringToBool(isTicketsOrderHome);
    isForceShortOnboarding = stringToBool(isForceShortOnboarding);
    isRetailCustomer = stringToBool(isRetailCustomer);
    isReactivatedCustomer = stringToBool(isReactivatedCustomer);

    amount = convertUndefined(amount);
    product = convertUndefined(product);
    branding = convertUndefined(branding);
    team = convertUndefined(team);

    weeks = ((_weeks = weeks) === null || _weeks === void 0 || (_weeks$toLowerCase = _weeks.toLowerCase) === null || _weeks$toLowerCase === void 0 ? void 0 : _weeks$toLowerCase.call(_weeks)) !== 'undefined' && !isNaN(parseInt(weeks, 10)) ? parseInt(weeks, 10) : undefined;

    isForceShortOnboarding = isForceShortOnboarding || (returnUrl === null || returnUrl === void 0 ? void 0 : returnUrl.includes('fso=true'));

    const isShortRegistrationFlow = isSubscription || isGift || isValidateTicketOnline || isForceShortOnboarding || isReactivatedCustomer;

    extraParams = {
      amount,
      branding,
      entryPoint,
      forceShortOnboarding: isForceShortOnboarding,
      gift: isGift,
      isRetailCustomer,
      isShortRegistrationFlow,
      product,
      subscription: isSubscription,
      team,
      ticketsorderhome: isTicketsOrderHome,
      validateticketonline: isValidateTicketOnline,
      weeks
    };

    const isAllUndefinedExtraParams = checkAllParamsUndefined(extraParams);
    if (!isAllUndefinedExtraParams) {
      theme = onboardingTheme.getTheme(branding);
      extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
        theme
      });
      await setExtraData({
        extraParams,
        req
      });
    } else {
      const sessionExtraParams = await getExtraData(req);
      if (sessionExtraParams) {
        theme = (sessionExtraParams === null || sessionExtraParams === void 0 ? void 0 : sessionExtraParams.theme) || onboardingTheme.getTheme();
      } else {
        theme = onboardingTheme.getTheme();
      }
      extraParams = _objectSpread(_objectSpread({}, extraParams), {}, {
        theme
      });
    }
  }

  await saveEntryPoint(extraParams, returnUrl, req);
  return extraParams;
};
const exportFunctions = {
  setupExtraData,
  getExtraData,
  setExtraData,
  updateExtraData,
  clearExtraData
};

if (isServer) {
  module.exports = exportFunctions;
} else {
  svs.accountservices.onboardingHandler = _objectSpread(_objectSpread({}, svs.accountservices.onboardingHandler), exportFunctions);
}

 })(window);